import { ReactElement } from 'react'

import ConsultZipCodeImpl from 'modules/user/domain/usecases/ConsultZipCodeImpl'
import ValidateAnttImpl from 'modules/user/domain/usecases/ValidateAnttImpl'
import ValidateCnpjImpl from 'modules/user/domain/usecases/ValidateCnpjImpl'
import ValidateEmailImpl from 'modules/user/domain/usecases/ValidateEmailImpl'
import VerifyCnpjAvailabilityImpl from 'modules/user/domain/usecases/VerifyCnpjAvailabilityImpl'
import VincularCNPJImpl from 'modules/user/domain/usecases/VincularCnpjImpl'
import UserRepository from 'modules/user/infra/repositories/UserRepository'
import VincularCnpj from 'modules/user/pages/VincularCnpj'

export const VincularCnpjFactory = (): ReactElement => {
  const userRepository = new UserRepository()
  const consultZipCode = new ConsultZipCodeImpl(userRepository)
  const validateCnpj = new ValidateCnpjImpl(userRepository)
  const validateAntt = new ValidateAnttImpl(userRepository)
  const validateEmail = new ValidateEmailImpl(userRepository)
  const verifyCnpjAvailability = new VerifyCnpjAvailabilityImpl(userRepository)
  const vincularCnpj = new VincularCNPJImpl(userRepository)

  return (
    <VincularCnpj
      consultZipCode={consultZipCode}
      validateCnpj={validateCnpj}
      validateAntt={validateAntt}
      validateEmail={validateEmail}
      verifyCnpjAvailability={verifyCnpjAvailability}
      vincularCnpj={vincularCnpj}
    />
  )
}
